import * as model from './model';
import * as view from './view';

export default function (){

    const links = document.querySelectorAll('[data-auth-form]');

    links.forEach((link) => {
        link.addEventListener('click', () => {
            // model.initFormAjax();

            setTimeout(function(){
                const form = document.querySelector('.dws_modal_auth');
                const inputsText = form.querySelectorAll('.input_text');
                const button = form.querySelector('.submit_button');
                const licenseKey = form.querySelector('input[name=LICENSE_KEY]')
                model.eventFormClick(form);

                // Нажали кнопку войти
                BX.bind(button, 'click', (e) => model.submitButtonPressed(e, inputsText, licenseKey.value));

            }, 100);
        })
    })

}